import Vue from 'vue'
import App from './App.vue'
import router from './router'

// axios、ajax封装
import * as http from './api/request'
// 统一接口管理
import api from './api/api'
// TODO Mock模拟数据，发布需调整
// import api from './api/apiMock'
// echarts图表
import * as echarts from 'echarts'
import 'element-ui/lib/theme-chalk/index.css'
// element-ui组件模块
import '@/ele.js'
import './api/dateTools.js'
import './api/rem'
import 'animate.css'

// import './mock'

// 图片预览功能
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
Vue.use(VueDirectiveImagePreviewer)

import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)

import VueVideoPlayer from 'vue-video-player'
import 'videojs-flash'
import 'videojs-contrib-hls'
import 'videojs-flvjs-es6'

window.videojs = VueVideoPlayer.videojs
Vue.prototype.$http = http
Vue.prototype.$echarts = echarts
Vue.prototype.$api = api
Vue.config.productionTip = false

new Vue({
	router,
	render: (h) => h(App),
}).$mount('#app')
